module.exports = __webpack_public_path__ + "images/emoji/door.f5e80c34808c314cbf78.png";